module.exports = __webpack_public_path__ + "static/media/Squall.2efafa41.jpg";